/* 
    Houses the data used in the displaydata window and it's popups.
    Data structure: 
      "NAME OF THE ITEM 1" 
            {"SUB ITEMS NAME"
            "SUB ITEMS DATA"
            "LINK TO SUB ITEMS DATA"}
            {"SUB ITEMS NAME"
            "SUB ITEMS DATA"
            "LINK TO SUB ITEMS DATA"}
      "NAME OF THE ITEM 2"
            "{SUB ITEMS NAME ...}"   
            "...." 

*/

const TreeData = {
  "Supporting services": [
    {
      title:
        "The basis of all ecosystems and their services, including living spaces for plants or animals and maintaining a diversity of plants and animals.",
      items: [
        {
          name: "Habitat for species",
          title: "Habitat for species",
          data: "Ecosystems provide living spaces for plants and animals; they also maintain a diversity of complex processes that underpin the other ecosystem services.",
          link: "",
        },
        {
          name: "Maintenance of genetic and biological diversity",
          title: "Maintenance of genetic and biological diversity",
          data: "Genetic diversity (the variety of genes between, and within, species populations) distinguishes different breeds or races from each other, providing the basis for locally well-adapted cultivars and a gene pool for developing commercial crops and livestock.",
          link: "",
        },
        {
          name: "Nutrient cycling",
          title: "Nutrient cycling",
          data: "The movement and exchange of inorganic and organic matter back into the production of matter.",
          link: "",
        },
        {
          name: "Primary production",
          title: "Primary production",
          data: "The production of chemical energy in organic compounds by living organisms. The main source of this energy is sunlight.",
          link: "",
        },
        {
          name: "Soil formation & water resources",
          title: "Soil formation & water resources",
          data: "Soil formation is the process of soil genesis as regulated by the effects of place, environment, and history. Natural sources of fresh water include surface water, under river flow, groundwater and frozen water.",
          link: "",
        },
      ],
    },
  ],
  "Regulating services": [
    {
      title: "",
      items: [
        {
          name: "Biological control",
          title: "Biological control",
          data: "The activities of predators and parasites in ecosystems that act to control populations of potential pest and disease vector.",
          link: "",
        },
        {
          name: "Carbon sequestration and storage",
          title: "Carbon sequestration and storage",
          data: "Ecosystems regulate the global climate by absorbing greenhouse gases and storing carbon.",
          link: "",
        },
        {
          name: "Erosion prevention and maintenance of soil fertility",
          title: "Erosion prevention and maintenance of soil fertility",
          data: "Vegetation cover prevents soil erosion and ensures soil fertility through natural biological processes such as nitrogen fixation.",
          link: "",
        },
      ],
    },
    {
      title: "",
      items: [
        {
          name: "Local climate and air quality",
          title: "Local climate and air quality",
          data: "Ecosystems influence the local climate and air quality. Trees provide shade whilst forests influence rainfall and water availability both locally and regionally. Trees or other plants also play an important role in regulating air quality by removing pollutants from the atmosphere.",
          link: "",
        },

        {
          name: "Moderation of extreme events",
          title: "Moderation of extreme events",
          data: "Ecosystems and living organisms create buffers against natural disasters, reduce damage from floods, storms, tsunamis, avalanches, landslides and droughts.",
          link: "",
        },
        {
          name: "Pollination",
          title: "Pollination",
          data: "Wind, bees and other insects, birds, bats pollinate plants and trees which is essential for the development of fruits, vegetables and seeds.",
          link: "",
        },
        {
          name: "Regulation of water flow",
          title: "Regulation of water flow",
          data: "Wind, bees and other insects, birds, bats pollinate plants and trees which is essential for the development of fruits, vegetables and seeds.",
          link: "",
        },
        {
          name: "Water treatment",
          title: "Water-water treatment",
          data: "Forests, wetlands and some other ecosystems filter effluents, decompose waste through the biological activity of microorganisms, and eliminate harmful pathogens.",
          link: "",
        },
      ],
    },
  ],
  "Provisioning services": [
    {
      items: [
        {
          name: "Food and feed supply",
          title: "Food and feed supply ",
          data: "Ecosystems provide the conditions for growing, collecting, hunting or harvesting food and feed.",
          link: "",
        },
        {
          name: "Freshwater",
          title: "Freshwater",
          data: "Ecosystems play a vital role in providing the flow and storage of fresh water.",
          link: "",
        },
        {
          name: "Medicinal resources",
          title: "Medicinal resources",
          data: "Natural ecosystems provide a variety of living species, including wild animals, plants, mushrooms, which offer effective cures for many kinds of health problems.",
          link: "",
        },
        {
          name: "Raw materials",
          title: "Raw materials",
          data: "Ecosystems provide a great diversity of materials including wood, biofuels, and fibers from wild or cultivated plant and animal species.",
          link: "",
        },
      ],
    },
  ],
  "Cultural services": [
    {
      items: [
        {
          name: "Aesthetic appreciation and inspiration for culture, art and design",
          title:
            "Aesthetic appreciation and inspiration for culture, art and design",
          data: "Animals, plants, natural landscapes and ecosystems have been the source of inspiration for much of our arts, culture, and design; they increasingly inspire science as well.",
          link: "",
        },
        {
          name: "Recreation, mental and physical health",
          title: "Recreation, mental and physical health",
          data: "Nature-based opportunities for recreation play an important role in maintaining mental and physical health, e.g. hiking in forests and mountains, playing sports in parks, cycling in urban green spaces.",
          link: "",
        },
        {
          name: "Spiritual experience and sense of place",
          title: "Spiritual experience and sense of place",
          data: "Nature is a common element in most major religions. Natural heritage, spiritual sense of belonging, traditional knowledge, and associated customs are important for creating a sense of belonging.",
          link: "",
        },
        {
          name: "Tourism",
          title: "Tourism",
          data: "Enjoyment of nature is the cultural ecosystem service which includes both benefits to visitors and income opportunities for the tourism service providers.",
          link: "",
        },
      ],
    },
  ],
  "Natural Capital": [
    {
      title:
        "Natural capital is another term for the stock of renewable and non-renewable resources (e.g plants, animals, air, water soils, miners) that combine to yield a flow of benefits to people.",
      items: [],
    },
  ],
  "Services": [
    {
      title:
        "Services encompass a wide range of intangible economic activities provided by one party to another to fulfill specific needs or demands. Services cannot be touched or held; instead, they involve actions, performances, or processes that deliver value to individuals, businesses, or communities. E.g. professional services such as legal advice and consulting, financial services such as investments, insurance, and green finance, educational services such as teaching and training, as well as entertainment and hospitality services, among others.",
      items: [],
    },
  ],

  "Wood based products": [
    {
      items: [
        {
          name: "Bioplastics",
          title: "Bioplastics",
          data: ".",
          subItems: [
            {
              name: "Utensils",
              title: "Utensils",
              data: "A utensil (Latin utensilia means 'things for use') is a tool, such as a knife, fork, spoon, chopstick, pencil, that we hold in our hands and use.",
              link: "",
            },
            {
              name: "3D-printing materials",
              title: "3D-printing materials",
              data: "3D-printing materials can be made of bioplastics. Polylactide (PLA) is a common bio-material used in 3D-printing nowadays.",
              link: "",
            },
            {
              name: "Agricultural materials",
              title: "Agricultural materials",
              data: "Agricultural material means material of plant or animal origin, which result from the production and processing of agricultural, horticultural, aquacultural, silvicultural, floricultural, vermicultural, or viticultural products. Sometimes it is made of manures, orchard and vineyard prunings, and crop residues.",
              link: "",
            },
            {
              name: "Boxes",
              title: "Boxes",
              data: "A box (plural: boxes) is a container used for the storage or transportation of its contents, mostly the boxes have flat, parallel, rectangular sides. Bioplastic boxes are more widely used now.",
              link: "",
            },
            {
              name: "Bags",
              title: "Bags",
              data: "A bag (also known as a sack) is a common tool in the form of a non-rigid container. The earliest bags were made of animal skin, cotton, or woven plant fibers, now the bioplastic bags are becoming widespread.",
              link: "",
            },
            {
              name: "Plastic films",
              title: "Plastics",
              data: "Plastic film is a thin continuous polymeric material, which can be made on biomaterials and used for packaging, plastic bags, labels, building construction, landscaping, etc.",
              link: "",
            },
          ],
        },
        {
          name: "Chemicals",
          title: "Chemicals",
          data: ".",
          subItems: [
            {
              name: "Nano-crystalline cellulose",
              title: "Nano-crystalline cellulose",
              data: "Nanocellulose can be obtained from wood-based fibers by an acid hydrolysis. The resulting material is known as cellulose nanocrystal (CNC), which can be used for manufacture of paper and paperboard, composites, food, additives, hygiene products, medical and cosmetics products, bio-based electronics and even energy storage.",
              link: "",
            },
            {
              name: "Betulin",
              title: "Betulin",
              data: "It is a naturally occurring triterpene produced from the bark of birch trees. It is used for treating of skin ailments, such as pre-carcinoma of skin and actinic keratoses.",
              link: "",
            },
            {
              name: "Tall oil",
              title: "Tall oil",
              data: "It is a viscous yellow-black odorous liquid obtained as a by-product of the kraft process of wood pulp manufacture when pulping mainly coniferous trees. Often uses as a component of adhesives, rubbers, and inks, and as an emulsifier.",
              link: "",
            },
            {
              name: "Tannins",
              title: "Tannins",
              data: "Tannins are the polyphenolic biomolecules that bind to and precipitate proteins and various other organic compounds. They are used as an important ingredient in the process of tanning (coloring) leather, production of anti-corrosive primers and recovering uranium from seawater.",
              link: "",
            },
            {
              name: "Resin",
              title: "Resin",
              data: "It is a solid or highly viscous substance of plant which is convertible into polymers. Plant resins are valued for the production of varnishes, adhesives, and food glazing agents.",
              link: "",
            },
            {
              name: "Ethanol",
              title: "Ethanol",
              data: "Ethanol is a volatile, flammable, colorless liquid, used as anesthetic, antiseptic, antidote, medicinal solvent, pharmacological product, fuel, solvent and more.",
              link: "",
            },
            {
              name: "Naphtha",
              title: "Naphtha",
              data: "Naphtha is a flammable liquid hydrocarbon mixture, used for production of fuels, plastics and more.",
              link: "",
            },
          ],
        },
        {
          name: "Pulp",
          title: "Pulp",
          data: "Pulp is a lignocellulosic fibrous material prepared by chemically or mechanically separating cellulose fibers from wood, fiber crops, waste paper, or rags. Mixed with water and other chemical or plant-based additives, pulp is the major raw material used in papermaking and the industrial production of other paper products.",
          subItems: [
            {
              name: "Printing/writing papers",
              title: "Printing/writing papers",
              data: "Printing/writing papers are paper grades used for newspapers, magazines, catalogs, books, notebooks, commercial printing, business forms, stationeries, copying and digital printing. About 1/3 of the total pulp production is used for these kinds of paper.",
              link: "",
            },
            {
              name: "Tissue paper",
              title: "Tissue paper",
              data: "Tissue paper is a lightweight paper, which is very versatile and can be used as hygienic and facial tissues, paper towels, packing material and so on. Presently, more companies are increasingly using recycled fibres in tissue paper production.",
              link: "",
            },
            {
              name: "Paper bags",
              title: "Paper bags",
              data: "Paper bags are usually made of kraft paper. They are commonly used as shopping carrier bags and for packaging of consumer goods. Paper bags can be made to withstand more pressure or weight than plastic bags do.",
              link: "",
            },
            {
              name: "Cardboards",
              title: "Cardboards",
              data: "Cardboard is a generic term for heavy paper-based products. The construction can range from a thick paper known as paperboard to corrugated fiberboard which is made of multiple plies of material. The term 'cardboard' has general use in English and French, but in commerce and industry more specific terminology is used.",
              link: "",
            },
            {
              name: "Cartons",
              title: "Cartons",
              data: "A carton is a box or container usually made of liquid packaging board, paperboard and sometimes of corrugated fiberboard. Many types of cartons are used in packaging. There are different types of cartons, e.g. folding, egg, aseptic, perga, gable, waxed paperboard beverage and other cartons.",
              link: "",
            },
            {
              name: "Pallets",
              title: "Pallets",
              data: "A pallet is a flat transport structure, which supports goods in a stable fashion while being lifted using some equipment. A pallet is the structural foundation of a unit load, which allows handling and storage efficiencies. Goods in shipping containers are often placed on a pallet secured with strapping, stretch wrap or shrink wrap and shipped. Most pallets in the world are wooden, but they also can be made on paper and recycled materials.",
              link: "",
            },
            {
              name: "Viscose",
              title: "Viscose",
              data: "Viscose (also called rayon) is a semi-synthetic fiber made from natural sources of regenerated cellulose, such as wood. It has the same molecular structure as cellulose. Many types and grades of viscose fibers and films exist. Some imitate the feel and texture of natural fibers such as silk, wool, cotton, and linen. It is used to make textiles for clothing and other purposes.",
              link: "",
            },
            {
              name: "Lyocell",
              title: "Lyocell",
              data: "Lyocell is a semi-synthetic fiber used to make textiles for clothing and other purposes. It is a form of regenerated cellulose made by dissolving pulp and dry jet-wet spinning. Lyocell production does not use carbon disulfide, which is toxic to workers and the environment.",
              link: "",
            },
            {
              name: "Thermal insulation",
              title: "Thermal insulation",
              data: "Thermal insulation is the reduction of heat transfer between objects in thermal contact or in range of radiative influence. Thermal insulation can be achieved with specially engineered methods or processes, as well as with suitable object shapes and materials. Different wood-based materials are used for insulation, e.g. cardboard, wood foam, wood panels, wood chips, soft- and hardwood.",
              link: "",
            },
          ],
        },
        {
          name: "Wood composites",
          title: "Wood composites",
          data: "Wood-plastic composites are composite materials made of wood fiber/wood flour and thermoplastics such as polythene, polypropylene, polyvinyl chloride and others. In addition to wood fiber and plastic, they may can also contain other ligno-cellulosic materials and no cellulose-based fiber fillers such as pulp fibers, peanut hulls, coffee husk, bamboo, straw, digestate, etc.",
          subItems: [
            {
              name: "Decking material",
              title: "Decking material",
              data: "The traditional decking material is pressure-treated wood. The current material is composite decking, which is typically made from wood-plastic composite. Such materials do not warp, crack, or split and are as versatile as traditional pressure treated wood. The lifespan of wood decking can be about 10 years, while wood-plastic composite decks can last for 20-50 years.",
              link: "",
            },
            {
              name: "Siding",
              title: "Siding",
              data: "Siding is the protective material attached to the exterior side of a wall of a house or other building. Along with the roof, it forms the first line of defense against the elements, most importantly sun, rain/snow, heat and cold. Wood siding is very versatile in style and can be used on a wide variety of building structures. The wood siding materials include clapboards, drop siding, shingles, vertical boards, wooden sheet siding and others.",
              link: "",
            },
            {
              name: "Fencing",
              title: "Fencing",
              data: "Fences of wood are widely used for various purposes. Agricultural fences are often built of wood, particularly on horse farms or where livestock are likely to challenge the fence. Homeowners often prefer wooden fences made of cedar, redwood and teak, pressure-treated and chemically treated wood pickets. ",
              link: "",
            },
            {
              name: "Sinks",
              title: "Sinks",
              data: "Sinks can be made of different materials and in different forms. Beautiful and 100% waterproof sinks can be made of wood, including wood kitchen sinks, teak wood vessel sinks, and even wood bath and soaking tubs.",
              link: "",
            },
            {
              name: "Containers",
              title: "Containers",
              data: "A container is any receptacle or enclosure for holding a product used in storage, packaging, and transportation, including shipping. A wooden container may be made of several types of wood; lumber (timber), plywood, engineered woods, etc. For some purposes, decorative woods are used.",
              link: "",
            },
            
          ],
        },
        {
          name: "Bioenergy products",
          title: "Bioenergy products",
          data: "Bioenergy is energy made or generated from biomass, which consists of recently living (but now dead) organisms, mainly plants. Bioenergy is considered as a renewable form of energy. Wood biomass is commonly used for bioenergy.",
          subItems: [
            {
              name: "Firewood",
              title: "Firewood",
              data: "Firewood is any wooden material that is used for fuel. Generally, firewood is in a log or branch form, it is not heavily processed. Firewood can be seasoned and heat treated (dry) or unseasoned (fresh/wet). It is generally classified as either hardwood or softwood.",
              link: "",
            },
            {
              name: "Woodchips",
              title: "Woodchips",
              data: "Woodchips are small- to medium-sized pieces of wood formed by cutting or chipping larger pieces of wood such as trees, branches, logging residues, stumps, roots, and wood waste. Woodchips can be used in a fully automated heating system.",
              link: "",
            },
            {
              name: "Pellets",
              title: "Pellets",
              data: "Pellets are a type of solid fuel made from compressed organic material. Wood pellets are the most common type of pellet fuel and are generally made from compacted sawdust and related industrial wastes from the milling of lumber, manufacture of wood products and furniture, and construction. Pellets are extremely dense and can be produced with a low moisture content (below 10%) that allows them to be burned with a very high combustion efficiency. They can be fed to a burner by auger feeding or by pneumatic conveying.",
              link: "",
            },
            {
              name: "Briquettes",
              title: "Briquettes",
              data: "Briquettes are a fuel source made out of dried, compacted wood. They are made from wood waste or byproducts and machine-compressed into a log or block shape.",
              link: "",
            },
            {
              name: "Biochar",
              title: "Biochar",
              data: "Biochar (charcoal) is the lightweight black residue, made of carbon and ashes, remaining after the pyrolysis of wood biomass. Charcoal can be used for syngas production and automotive fuel, for cooking purposes (barbecue grill), or as fuel for industries and energy facilities.",
              link: "",
            },
            {
              name: "Sawdust",
              title: "Sawdust",
              data: "Sawdust (or wood dust) is a by-product or waste product of woodworking operations such as sawing, sanding, milling, planing, and routing. It is composed of small chippings of wood. It can be used for various purposes, including energy generation.",
              link: "",
            },
            {
              name: "Wood gas",
              title: "Wood gas",
              data: "Wood gas is a fuel gas that can be used for furnaces, stoves, and vehicles. During the production process, wood biomass is gasified within the oxygen-limited environment of a wood gas generator to produce a combustible mixture. Wood gas contains a variety of organic compound that require scrubbing for use in other applications.",
              link: "",
            },
            {
              name: "Liquid wood fuel",
              title: "Liquid wood fuel",
              data: "Liquid wood fuel is a product similar to traditional petroleum products but based on wood biomass. Wood pulp is heated in the absence of oxygen during a pyrolysis process, producing “liquid smoke”, which allows wood to be converted from a solid into a liquid. The technology is based on a well-known Fischer–Tropsch process of conversion of syngas into liquid hydrocarbons.",
              link: "",
            },
          ],
        },
        /* {
          name: "Sawn wood",
          title: "Sawn wood",
          data: ".",
          subItems: [
            {
              name: "Beams",
              title: "Beams",
              data: ".",
              link: "",
            },
            {
              name: "Trusses",
              title: "Trusses",
              data: ".",
              link: "",
            },
            {
              name: "Frames",
              title: "Frames",
              data: ".",
              link: "",
            },
            {
              name: "Windows",
              title: "Windows",
              data: ".",
              link: "",
            },
            {
              name: "Doors",
              title: "Doors",
              data: ".",
              link: "",
            },
            {
              name: "Flooring",
              title: "Flooring",
              data: ".",
              link: "",
            },
            {
              name: "Chairs",
              title: "Chairs",
              data: ".",
              link: "",
            },
            {
              name: "Tables",
              title: "Tables",
              data: ".",
              link: "",
            },
            {
              name: "Cabinetry",
              title: "Cabinetry",
              data: ".",
              link: "",
            },
            {
              name: "Pallets",
              title: "Pallets",
              data: ".",
              link: "",
            },
            {
              name: "Crates",
              title: "Crates",
              data: ".",
              link: "",
            },
            {
              name: "Barrels",
              title: "Barrels",
              data: ".",
              link: "",
            },
            {
              name: "Veneer-based",
              title: "Veneer-based",
              data: ".",
              link: "",
            },
          ],
        }, */
        {
          name: "Engineered wood products",
          title: "Engineered wood products",
          data: "Engineered wood includes a range of derivative wood products which are manufactured by binding or fixing the strands, particles, fibres, or veneers or boards of wood, together with adhesives, or other methods of fixation to form composite material. Engineered wood products are made from hardwoods and softwoods, sawmill scraps and other wood waste. There are several dozens of international standards related to engineered wood products.",
          subItems: [
            {
              name: "Plywood",
              title: "Plywood",
              data: "Plywood, a wood structural panel, is sometimes called the original engineered wood product. Plywood is manufactured from sheets of cross-laminated veneer and bonded under heat and pressure with durable, moisture-resistant adhesives. By alternating the grain direction of the veneers from layer to layer, or 'cross-orienting', panel strength and stiffness in both directions are maximized.",
              link: "",
            },
            {
              name: "OSB",
              title: "OSB",
              data: "Oriented strand board (OSB) is a type of engineered wood formed by adding adhesives and then compressing layers of wood strands (flakes) in specific orientations. OSB is a material with favorable mechanical properties that make it particularly suitable for load-bearing applications in construction.",
              link: "",
            },
            {
              name: "MDF / HDF",
              title: "MDF / HDF",
              data: "Medium-density fibre (MDF) is an engineered wood product made by breaking down hardwood or softwood residuals into wood fibre combining it with wax and a resin binder, and forming it into panels by applying high temperature and pressure. Hardboard, also called high-density fiberboard (HDF), is an engineered wood product used in furniture and in the construction industry.",
              link: "",
            },
            {
              name: "Particle board",
              title: "Particle board",
              data: "Particle board is manufactured from wood chips, sawmill shavings, or even sawdust, and a synthetic resin or another suitable binder, which is pressed and extruded.",
              link: "",
            },
            {
              name: "SCL",
              title: "SCL",
              data: "Structural composite lumber (SCL) is a class of materials made with layers of veneers, strands, or flakes bonded with adhesives. Unlike wood structural panels, structural composite lumber products generally have all grain fibers oriented in the same direction.",
              link: "",
            },
            {
              name: "LVL",
              title: "LVL",
              data: "Laminated veneer lumber (LVL) is an engineered wood product that uses multiple layers of thin wood assembled with adhesives. It is typically used for headers, beams, rimboard, and edge-forming material. LVL is considered to be a highly reliable building material that provides many of the same attributes associated with large sized timbers.",
              link: "",
            },
            {
              name: "PSL",
              title: "PSL",
              data: "Parallel strand lumber (PSL) consists of long veneer strands laid in parallel formation and bonded together with an adhesive to form the finished structural section. A strong, consistent material, it has a high load-carrying ability and is resistant to seasoning stresses so it is well suited for use as beams and columns for post and beam construction, and for beams, headers, and lintels for light framing construction.",
              link: "",
            },
            {
              name: "LSL",
              title: "LSL",
              data: "Laminated strand lumber (LSL) and oriented strand lumber (OSL) are manufactured from flaked wood strands that have a high length-to-thickness ratio. Combined with an adhesive, the strands are oriented and formed into a large mat or billet and pressed.",
              link: "",
            },
            {
              name: "I-joists",
              title: "I-joists",
              data: "I-joists are 'I'-shaped structural members designed for use in floor and roof construction. A I-joists are designed to carry heavy loads over long distances while using less lumber than a dimensional solid wood joist of a size necessary to do the same task.",
              link: "",
            },
            {
              name: "Mass timber",
              title: "Mass timber",
              data: "Mass timber, also known as engineered timber, is a class of large structural wood components for building construction. Mass timber components are made of lumber or veneers bonded with adhesives or mechanical fasteners. Certain types of mass timber, such as nail-laminated timber and glue-laminated timber, have existed for over a hundred years.",
              link: "",
            },
            {
              name: "CLT",
              title: "CLT",
              data: "Cross-laminated timber (CLT) is a subcategory of engineered wood with panel product made from gluing together at least three layers of solid-sawn lumber. Each layer of boards is usually oriented perpendicular to adjacent layers and glued on the wide faces of each board, often in a symmetric way so that the outer layers have the same orientation. By gluing layers of wood at right angles, the panel is able to achieve better structural rigidity in both directions. CLT is used for construction of various structures around the world, including pavilions, plyscrapers,  bridges, parking structures, modular constructions and others. CLT is considered sustainable because it's made from renewable wood that can be harvested responsibly. CLT production is eco-friendly, generating fewer greenhouse gas emissions and using less energy than traditional materials like concrete and steel. CLT can help reduce a building's carbon footprint, as it stores carbon dioxide absorbed by trees. Its lightweight, prefabricated design minimizes waste and improves construction efficiency. CLT is durable and long-lasting, with a projected lifespan of over 100 years, making it a promising option for sustainable construction.",
              link: "",
            },
            {
              name: "Glulam",
              title: "Glulam",
              data: "Glued laminated timber (glulam) is a type of structural engineered wood product constituted by layers of dimensional lumber bonded together with durable, moisture-resistant structural adhesives so that all of the grain runs parallel to the longitudinal axis. There are several advantages to using glulam in construction: versatility, strength and stiffness, size and shape, environmental friendliness, fire safety.",
              link: "",
            },
            {
              name: "DLT",
              title: "DLT",
              data: "Dowel laminated timber (DLT) is made by placing multiple boards of softwood lumber next to each together, each with a hole so that a hardwood dowel can be friction fitted through all of them. As DLT dries to reach an equilibrium moisture content with the softwood lumber, it expands into the surrounding boards creating a connection. The use of a dowel connection eliminates the need for any metal fasteners or adhesives.",
              link: "",
            },
            {
              name: "NLT",
              title: "NLT",
              data: "Nail laminated timber (NLT) is a mass timber product that consists of parallel boards fastened with nails. It can be used to create floors, roofs, walls, and elevator shafts within a building. No chemical adhesives are used, and wood fibers are oriented in the same direction.",
              link: "",
            },
            {
              name: "Engineered wood flooring",
              title: "Engineered wood flooring",
              data: "Engineered wood flooring is a type of flooring product, similar to hardwood flooring, made of layers of wood or wood-based composite laminated together. The floor boards are usually milled with a tongue-and-groove profile on the edges for consistent joinery between boards.",
              link: "",
            },
            {
              name: "Densified wood",
              title: "Densified wood",
              data: "Densified wood can be made by using a mechanical hot press to compress wood fibers, sometimes in combination with chemical modification of the wood. The densified wood possessed mechanical strength properties on par with steel used in building construction, opening the door for applications of densified wood in situations where regular strength wood would fail.",
              link: "",
            },
            {
              name: "Thermally efficient wood",
              title: "Thermally efficient wood",
              data: "Thermally efficient wood. Removing lignin from wood alters the mechanical, thermal, optical, fluidic and ionic properties and functions of the natural wood and is an effective approach to regulating its thermal properties. Delignified wood not only possesses a lower thermal conductivity than natural wood, and it has better thermal performance than most commercially available insulating materials.",
              link: "",
            },
            {
              name: "Moldable wood",
              title: "Moldable wood",
              data: "Moldable wood. Using chemical modification techniques, wood can be made extremely moldable using a combination of delignification and water shock treatment. This emerging technology is not yet used in industrial processes. However, initial tests show promising advantages in improved mechanical properties, with the molded wood exhibiting strength comparable to some metal alloys.",
              link: "",
            },
            {
              name: "Transparent wood composites",
              title: "Transparent wood composites",
              data: "Transparent wood composites are new materials, only made at the laboratory scale, that combines transparency and stiffness via a chemical process that replaces light-absorbing compounds, such as lignin, with a transparent polymer.",
              link: "",
            },
          ],
        },
        {
          name: "Wood panels",
          title: "Wood panels",
          data: "Wood panels are used in architecture and design for decorative treatment of walls, ceilings, doors, and furniture consisting of a series of wide, thin sheets of wood, called panels, framed together by narrower, thicker strips of wood.",
          subItems: [
            {
              name: "Plywood",
              title: "Plywood",
              data: "Plywood is a composite material manufactured from thin layers, or 'plies', of wood veneer that are glued together with adjacent layers, having their wood grain rotated up to 90° to one another. There are different types of plywood, including softwood, hardwood, tropical, aircraft, decorative, flexible, marine, and others.",
              link: "",
            },
            {
              name: "Hardboard",
              title: "Hardboard",
              data: "Hardboard, also called high-density fiberboard (HDF), is a type of fiberboard, which is an engineered wood product. It is used in furniture and in the construction industry.",
              link: "",
            },
            {
              name: "OSB",
              title: "OSB",
              data: "Oriented strand board (OSB) is a type of engineered wood formed by adding adhesives and then compressing layers of wood strands (flakes) in specific orientations. OSB is a material with favorable mechanical properties that make it particularly suitable for load-bearing applications in construction.",
              link: "",
            },
            {
              name: "MDF / HDF",
              title: "MDF / HDF",
              data: "Medium-density fibre (MDF) is an engineered wood product made by breaking down hardwood or softwood residuals into wood fibre combining it with wax and a resin binder, and forming it into panels by applying high temperature and pressure. Hardboard, also called high-density fiberboard (HDF), is an engineered wood product used in furniture and in the construction industry.",
              link: "",
            },
            {
              name: "Doors",
              title: "Doors",
              data: "A door is a hinged or otherwise movable barrier that allows ingress (entry) into and egress (exit) from an enclosure. Wooden doors – including solid wood doors – are a top choice for many homeowners, largely because of the aesthetic qualities of wood.",
              link: "",
            },
            {
              name: "Flooring",
              title: "Flooring",
              data: "Flooring is the general term for a permanent covering of a floor. Many different species of wood are fabricated into wood flooring in two primary forms: plank and parquet. Hardwoods are typically much more durable than softwoods. Engineered hardwood has a thin solid wood layer on top with a composite core. There are also bamboo and cork floorings, often considered as environmentally friendly.",
              link: "",
            },
            {
              name: "Beams",
              title: "Beams",
              data: "Beams are large pieces of wood that are able to bear heavy loads. They can be made of solid wood or engineered wood.",
              link: "",
            },
            {
              name: "Tables",
              title: "Tables",
              data: "A table is an item of furniture with a raised flat top and is supported most commonly by 1 to 4 legs. It is used as a surface for working at, eating from or on which to place things. Tables are often made of wood and wood-based materials. There are numerous types of tables, such as dining room tables, nightstands, coffee and tea tables, worktables, nested tables, billiard and chess tables, and others.",
              link: "",
            },
           
            {
              name: "Cabinetry",
              title: "Cabinetry",
              data: "A cabinet is a case or cupboard with shelves and/or drawers for storing or displaying items. Cabinets are commonly made of wood and wood derivatives such as MDF, Plywood, or Particle Board. Often a natural wood such as Maple, Oak, Ash, Birch, Cherry, or Alder is used in production of cabinets.",
              link: "",
            },
          ],
        },
      ],
    },
  ],

  "Non-wood products": [
    {
      items: [
        {
          name: "Fruits",
          title: "Fruits",
          data: "Fruit is a sweet and fleshy product of a tree or other plant that contains seed and can be consumed or used by animals and humans. There are simple fruits (e.g. berries, nuts, pomes, coconuts), aggregate and multiple fruits of 2000 types worldwide.",
          link: "",
        },
        {
          name: "Nuts",
          title: "Nuts",
          data: "A nut is a fruit consisting of a hard or tough nutshell protecting a kernel which is often edible. It is widely used for culinary, but also for other purposes.",
          link: "",
        },
        {
          name: "Mushrooms",
          title: "Mushrooms",
          data: "A mushroom is the fleshy, spore-bearing fruiting body of a fungus, typically produced above ground, on soil, or on its food source. There are at least 6,280,000 species on Earth.",
          link: "",
        },
        {
          name: "Wild Meat",
          title: "Wild Meat",
          data: "Wild meat refers to wild animals used for food. About 2000 species of invertebrates, amphibians, fish, reptiles, birds and mammals are used as wild meat globally.",
          link: "",
        },
        {
          name: "Honey",
          title: "Honey",
          data: "Honey is a sweet and viscous substance made by several bees, the best-known of which are honey bees. There are over 300 different varieties of honey produced worldwide.",
          link: "",
        },
        {
          name: "Aromatic Plants",
          title: "Aromatic Plants",
          data: "Aromatic plants are those that contain aromatic compounds – basically essential oils that are volatile at room temperature.",
          link: "",
        },
        {
          name: "Bee Wax",
          title: "Bee Wax",
          data: "Bee wax is a wax produced in the bee's hives by honeybees A. mellifera. It is used as plastic, lubricant and waterproofing agent, as a polish for wood and leather, for making candles, as an ingredient in cosmetics and more.",
          link: "",
        },
        {
          name: "Natural Remedies",
          title: "Natural Remedies",
          data: "Natural Remedies are those with active ingredients made from plant parts, such as leaves, roots or flowers, and other natural materials.",
          link: "",
        },
        {
          name: "Christmas Trees",
          title: "Christmas Trees",
          data: "Christmas tree is usually an evergreen conifer, often a pine, spruce, or fir, decorated with lights and ornaments as a part of Christmas festivities.",
          link: "",
        },
        {
          name: "Saps",
          title: "Saps",
          data: "Tree sap is used as a fresh drink, ingredient in food and beverages, making light alcoholic products, as supplementary nutrition, cosmetic applications for skin and hair, and folk medicinal use.",
          link: "",
        },
        {
          name: "Gums",
          title: "Gums",
          data: "Natural gums are long chains of polysaccharides, widely used in the food industry, diet products and medicines.",
          link: "",
        },
        {
          name: "Cork Products",
          title: "Cork Products",
          data: "Cork is one of nature’s most versatile materials harvested in southwest Europe and northwest Africa. 100% natural, reusable and recyclable.",
          link: "",
        },
      ],
    },
  ],

  Bioproducts: [
    {
      items: [
        {
          data: ".",
          name: "Wood-based products",
          title: "Wood-based products",
          subItems: [
            {
              name: "Sawn Wood",
              title: "Wood-based products",
              data: "Types: Softwood, Hardwood",
              link: "",
            },
            {
              name: "Wood Panels",
              title: "Wood Panels",
              data: "Types: Plywood, OSB, MDF",
              link: "",
            },
          ],
        },
        {
          data: ".",
          name: "Non-wood forest products",
          title: "Non-wood forest products",
          subItems: [
            {
              name: "Edible Plants",
              title: "Edible Plants",
              data: "Edible Plants",
              link: "",
            },
            {
              name: "Fruits",
              title: "Fruits",
              data: "Fruit is a sweet and fleshy product of a tree or other plant that contains seed and can be consumed or used by animals and humans. There are simple fruits (e.g. berries, nuts, pomes, coconuts), aggregate and multiple fruits of 2000 types worldwide.",
              link: "",
            },
            {
              name: "Nuts",
              title: "Nuts",
              data: "A nut is a fruit consisting of a hard or tough nutshell protecting a kernel which is often edible. It is widely used for culinary, but also for other purposes.",
              link: "",
            },
            {
              name: "Mushrooms",
              title: "Mushrooms",
              data: "A mushroom is the fleshy, spore-bearing fruiting body of a fungus, typically produced above ground, on soil, or on its food source. There are at least 6,280,000 species on Earth.",
              link: "",
            },
            {
              name: "Wild Meat",
              title: "Wild Meat",
              data: "Wild meat refers to wild animals used for food. About 2000 species of invertebrates, amphibians, fish, reptiles, birds and mammals are used as wild meat globally.",
              link: "",
            },
            {
              name: "Honey",
              title: "Honey",
              data: "Honey is a sweet and viscous substance made by several bees, the best-known of which are honey bees. There are over 300 different varieties of honey produced worldwide.",
              link: "",
            },
            {
              name: "Aromatic Plants",
              title: "Aromatic Plants",
              data: "Aromatic plants are those that contain aromatic compounds – basically essential oils that are volatile at room temperature.",
              link: "",
            },
            {
              name: "Bee Wax",
              title: "Bee Wax",
              data: "Bee wax is a wax produced in the bee's hives by honeybees A. mellifera. It is used as plastic, lubricant and waterproofing agent, as a polish for wood and leather, for making candles, as an ingredient in cosmetics and more.",
              link: "",
            },
            {
              name: "Natural Remedies",
              title: "Natural Remedies",
              data: "Natural Remedies are those with active ingredients made from plant parts, such as leaves, roots or flowers, and other natural materials.",
              link: "",
            },
            {
              name: "Christmas Trees",
              title: "Christmas Trees",
              data: "Christmas tree is usually an evergreen conifer, often a pine, spruce, or fir, decorated with lights and ornaments as a part of Christmas festivities.",
              link: "",
            },
            {
              name: "Saps",
              title: "Saps",
              data: "Tree sap is used as a fresh drink, ingredient in food and beverages, making light alcoholic products, as supplementary nutrition, cosmetic applications for skin and hair, and folk medicinal use.",
              link: "",
            },
            {
              name: "Gums",
              title: "Gums",
              data: "Natural gums are long chains of polysaccharides, widely used in the food industry, diet products and medicines.",
              link: "",
            },
            {
              name: "Cork Products",
              title: "Cork Products",
              data: "Cork is one of nature’s most versatile materials harvested in southwest Europe and northwest Africa. 100% natural, reusable and recyclable.",
              link: "",
            },
          ],
        },
      ],
    },
  ],
  "Sustainable businesses": [
    {
      title:
        "An enterprise that has a minimal negative impact or potentially a positive effect on the global or local environment, community, society, or economy—a business that strives to meet the triple bottom line.",
      items: [
        {
          name: "Agroforestry",
          title: "Agroforestry",
          data: "The land use systems in which trees are grown in combination with agriculture on the same land.",
          link: "",
        },
        {
          name: "Fisheries and aquaculture",
          title: "Fisheries and aquaculture",
          data: "The enterprise of raising or harvesting fish and other aquatic life.",
          link: "",
        },
        {
          name: "Sustainable forest management",
          title: "Sustainable forest management",
          data: "The stewardship and use of forests and forest lands in a way, and at a rate, that maintains their biodiversity, productivity, regeneration capacity, vitality and their potential to fulfill, now and in the future, relevant ecological, economic and social functions, at local, national, and global levels, and that does not cause damage to other ecosystems.",
          link: "",
        },
      ],
    },
  ],
  Bioenergy: [
    {
      title:
        "A source of energy from the organic material that makes up plants, known as biomass, which contains carbon absorbed by plants through photosynthesis. Modern bioenergy is the largest source of renewable energy globally today, accounting for 55% of renewable energy and over 6% of global energy supply.",
      items: [{}],
    },
  ],
  "Sustainable finance": [
    {
      title:
        "The set of financial regulations, standards, norms and products that pursue the socio-economic and environmental objectives. Green finance includes all lending and investment that contributes to climate mitigation, climate adaptation and resilience, and other environmental objectives – including biodiversity management.",
      items: [{}],
    },
  ],
  "Technologies / Innovations": [
    {
      title:
        "Technology is the application of scientific knowledge to the practical aims of human life or to the change and manipulation of the human environment. Innovation is the creation of a new way of doing something, whether the enterprise is concrete (e.g., the development of a new product) or abstract (e.g., the development of a new philosophy or theoretical approach to a problem).",
      items: [{}],
    },
  ],
  Biocities: [
    {
      title:
        "“Cities hosted by nature” and not “nature hosted in cities”, that understand green (trees, forests and plants) and blue (water) infrastructures as assets and not costs. They are constantly evolving and exposed to dynamic processes like nature itself. This needs natural, technical and social science knowledge.",
      items: [{}],
    },
  ],
  "Social capital": [
    {
      title:
        "The concept in social science that involves the potential of individuals to secure benefits and invent solutions to problems through membership in social networks. Social capital revolves around three dimensions: interconnected networks of relationships between individuals and groups (social ties or social participation), levels of trust that characterize these ties, and resources or benefits that are both gained and transferred by virtue of social ties and social participation.",
      items: [{}],
    },
  ],
  Careers: [
    {
      title:
        "'Career' as a person's 'course or progress through life (or a distinct portion of life)'.",
      items: [{}],
    },
  ],
  Education: [
    {
      title:
        "The transmission of knowledge, skills, and character traits. There are many types of education.",
      items: [{}],
    },
  ],
  Qualification: [
    {
      title:
        "Knowledge, skill, or some other characteristic that gives a person the ability or the right to do or have something.",
      items: [{}],
    },
  ],
  "Gender aspects": [
    {
      title:
        "“Gender” refers to the social and cultural construction of ways of being, of acting, of interacting, of perceiving others and which organises the distribution of power and resources between individuals.",
      items: [{}],
    },
  ],
  "Green jobs": [
    {
      title:
        "The decent jobs that contribute to preserve or restore the environment, be they in traditional sectors such as manufacturing and construction, or in new, emerging green sectors such as renewable energy and energy efficiency. Green jobs help improve energy and raw materials efficiency, limit greenhouse gas emissions, minimize waste and pollution, protect and restore ecosystems, support adaptation to the effects of climate change.",
      items: [{}],
    },
  ],
  Prosperity: [
    {
      title:
        "The flourishing, thriving, good fortune and successful social status. Prosperity often produces profuse wealth including other factors which can be profusely wealthy in all degrees, such as happiness and health.",
      items: [{}],
    },
  ],
  Wellbeing: [
    {
      title:
        "Refers to what is intrinsically valuable relative to someone.",
      items: [{}],
    },
  ],
  "Recycle, reuse, reduce": [
    {
      items: [{}],
    },
  ],
  "Cascading, efficiency, ecodesign": [
    {
      items: [{}],
    },
  ],
  "Biodegradation and closed nutrient cycles": [
    {
      items: [{}],
    },
  ],
  Circular: [
    {
      items: [
        {
          name: "Recycle, reuse, reduce",
          title: "Recycle, reuse, reduce",
          data: " Recycle: The process of converting waste materials into new materials and objects.\n\r Reuse: The action or practice of using an item, whether for its original purpose (conventional reuse) or to fulfill a different function (creative reuse or repurposing).\n Reduce: Reduction of consumption of materials, energy, etc.",
          link: "",
        },
        {
          name: "Cascading, efficiency, ecodesign",
          title: "Cascading, efficiency, ecodesign",
          data: "Cascading: Occurring in a sequence or successive stages. \n Efficiency: The ability to do things well, successfully, and without waste.\n      Ecodesign: An approach to designing products and services that gives special consideration to the environmental impacts of a product over its entire lifecycle.",
          link: "",
        },
        {
          name: "Biodegradation and closed nutrient cycles",
          title: "Biodegradation and closed nutrient cycles",
          data: "Biodegradation: The breakdown of organic matter by microorganisms, generally assumed to be a natural process.\n Closed nutrient cycles: A process which aims to compensate the exit of mineral elements that are necessary for animals and plants, such as nitrogen, phosphorus, potassium, and sulphur. Closing those cycles can improve self-sufficiency of farms and territories.",
          link: "",
        },
      ],
    },
  ],

  "": [
    {
      items: [],
    },
  ],

  // Add more nodes and data as needed
};

export default TreeData;



// WEBPACK FOOTER //
// ./src/data/TreeData.js